import React from "react";
import { Col, Row } from "react-bootstrap";
import myPhoto2 from "../../../assets/images/myPhoto2.png";
import { MdLocationPin } from "react-icons/md";
import { FaPhoneSquareAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { ImLinkedin } from "react-icons/im";

const AboutSection = () => {
  return (
    <div id="about" className="about-sec container">
      <div className="container">
        <div className="container-bg"></div>
        <div className="content">
          <Row>
            <Col md={6} className="image-sec">
              <img width="350px" src={myPhoto2} alt="" />
            </Col>
            <Col md={6} className="banner-txt">
              <div>
                <p>About me</p>
                <h2>Why you hire me </h2>
                <p className="banner-description">
                  A Proactive M.E.R.N Stack Developer fascinated by Web
                  Technologies. I have a deep interest in JavaScript and am
                  looking for opportunities to make the best use of my skills
                  and learn more.
                </p>
                <a href="#portfolio">
                  <button className="primary-btn">Portfolio</button>
                </a>
                <a href="https://drive.google.com/file/d/1s-mphrlSPnZWsUGJNii0XpT4M4yOkMAt/view?usp=sharing">
                  <button className="primary-btn">Resume</button>
                </a>
                <div className="social-media-contacts">
                  <Row md={2}>
                    <Col>
                      <a
                        className="contact-link"
                        target="_blank"
                        href="https://goo.gl/maps/2WLoCHqNkbBbTLtD8"
                      >
                        <p
                          data-toggle="tooltip"
                          title="Noapara, Abhaynagor, Jessore"
                        >
                          <MdLocationPin className="about-icon" /> Khulna,
                          Bangladesh
                        </p>
                      </a>
                      <a className="contact-link" href="tel: +8801722573437">
                        <p data-toggle="tooltip" title="+8801722-573437">
                          <FaPhoneSquareAlt className="about-icon" />
                          +8801722-573437
                        </p>
                      </a>
                    </Col>
                    <Col>
                      <a
                        className="contact-link"
                        href="https://www.linkedin.com/in/md-hasib01/"
                        target="_blank"
                      >
                        <p
                          data-toggle="tooltip"
                          title="linkedin.com/in/md-hasib01/"
                        >
                          <ImLinkedin className="about-icon" /> Linkedin
                        </p>
                      </a>
                      <a
                        className="contact-link"
                        href="mailto: md.hasibuzzaman001@gmail.com"
                      >
                        <p
                          data-toggle="tooltip"
                          title="md.hasibuzzaman001@gmail.com"
                        >
                          <MdEmail className="about-icon" /> Md Hasib
                        </p>
                      </a>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
